const ROOT = '/surveys';

const routes = {
  list: () => ROOT,
  item: (id) => `${ROOT}/${id}`,
  create: () => `${ROOT}/add`
};

export default routes;
